import { useContext } from 'react';
import { Button } from 'react-bootstrap';
import styled, { useTheme } from 'styled-components';

import { AppContext } from '../../../context/AppContext';
import { useActiveSubscription, useManageSubscription } from '../../../hooks';
import { formatDDMMMMYYYY } from '../../../utils/dateUtils';
import BasicSpinner from '../../BasicSpinner';
import ErrorLabel from '../../ErrorLabel';
import ExternalLink from '../../Icon/ExternalLink';
import { StyledSemiboldLabel } from '../../Styled';

import InformationPanel from './InformationPanel';

const StyledExternalLinkIcon = styled(ExternalLink)`
  position: relative;
  top: -2px;
  margin-left: 10px;
`;

const SubscriptionDetails = () => {
  const theme = useTheme();
  const { isAdmin } = useContext(AppContext);
  const { activeSubscription } = useActiveSubscription();
  const { onManageSubscription, redirecting, errorMessage } = useManageSubscription();

  const renewalTs = activeSubscription?.renewal_date ? Number(activeSubscription.renewal_date) * 1000 : null;
  const isExpired = renewalTs ? renewalTs < Date.now() : false;
  const dateLabel = isExpired ? 'Expired on' : 'Renews on';

  return (
    <InformationPanel title="Subscription details">
      <li>
        <StyledSemiboldLabel>Subscription type:</StyledSemiboldLabel> {activeSubscription?.subscription_name || '---'}
      </li>
      <li>
        <StyledSemiboldLabel>{dateLabel}:</StyledSemiboldLabel>{' '}
        {renewalTs ? formatDDMMMMYYYY(new Date(renewalTs)) : '---'}
      </li>
      <Button
        variant="secondary"
        className="pl-5 pr-5 mb-2"
        disabled={isAdmin}
        title={isAdmin ? 'Subscription management is handled via Stripe admin for internal users.' : undefined}
        onClick={() => {
          void onManageSubscription();
        }}
      >
        Manage Subscription
        {!redirecting ? <StyledExternalLinkIcon colour={theme.colors.primary} /> : <BasicSpinner />}
      </Button>
      {!!errorMessage && <ErrorLabel label={errorMessage} />}
    </InformationPanel>
  );
};

export default SubscriptionDetails;
